import { dia, elementTools, g } from '@joint/core';
export class ParallelogramOffsetControl extends elementTools.Control {

    protected override getPosition(view: dia.ElementView) {
        const { model } = view;
        const { width, height } = model.size();
        const controlLevel = height * (1 / 3);
        const attrs = model.get('attrs') || {};
        let offset = 0;
        if (attrs['control']) {
            offset  = attrs['control']['offset'] || 0;
        }
        const offsetSide = new g.Line(new g.Point(offset, 0), new g.Point(0, height));
        const levelLine = new g.Line(new g.Point(0, controlLevel), new g.Point(width, controlLevel));
        const controlPoint = offsetSide.intersect(levelLine);
        if (controlPoint) return controlPoint;
        return { x: 0, y: controlLevel };
    }

    protected override setPosition(view: dia.ElementView, coordinates: dia.Point) {
        const { model } = view;
        const { width } = model.size();
        let offset = coordinates.x * (3 / 2) ;
        offset = Math.max(0, Math.min(offset, width));
        const attrs = model.get('attrs') || {};
        if (attrs['control']) {
            attrs['control']['offset'] = offset;
            model.attr('body/d', `
                    M 0 calc(h)
                    L ${offset} 0
                    L calc(w) 0
                    L calc(w-${offset}) calc(h)
                    Z`
            );
        }
        
    }
}
